import { AppApiError } from '@modules/husleie-framework/src/types/App.entity';
import { Modals } from '@modules/husleie-framework/src/types/Modals.entity';
import type StaticDataState from '@modules/store/common/types/StaticDataState.entity';
import type Translation from '@modules/store/common/types/Translation.entity';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<StaticDataState> = {
  setLoading: (state, payload: boolean) => {
    state.loading = payload;
  },
  setApiError: (state: StaticDataState, payload: AppApiError) => {
    state.api.errorStatus = payload;
  },
  setLocale: (state, payload: string) => {
    state.locale = payload;
  },
  setLanguage: (state, payload: string) => {
    state.language = payload;
  },
  setTimezone: (state, payload: string) => {
    state.timezone = payload;
  },
  setTranslations: (state, payload: Translation[]) => {
    state.translations = payload;
  },
  setTranslation: (state, payload: Translation) => {
    const index: number = state.translations.findIndex(e => e.type === payload.type && e.name === payload.name);
    if (index >= 0) {
      state.translations.splice(index, 1, payload);
    } else {
      state.translations.push(payload);
    }
  },
  closeModal: state => {
    document.body.style.overflowY = 'auto';
    state.modal.open = false;
    state.modal.name = Modals.Null;
  },
  // Toggle modals
  openModal: (state, { name, closeable = true }) => {
    document.body.style.overflowY = 'hidden';
    state.modal.open = true;
    state.modal.name = name;
    state.modal.closeable = closeable;
  },
};
